import { render, staticRenderFns } from "./UpdateVideos.vue?vue&type=template&id=1a01b7f3"
import script from "./UpdateVideos.vue?vue&type=script&lang=js"
export * from "./UpdateVideos.vue?vue&type=script&lang=js"
import style0 from "./UpdateVideos.vue?vue&type=style&index=0&id=1a01b7f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports